import React, {createContext, useState} from "react";
import {BrowserRouter as Router, Redirect, Route} from "react-router-dom";
import HomePage from "./components/home/HomePage";
import UploadDocumentsPage from "./components/upload/UploadDocumentsPage";
import SuccessPage from "./components/final/SuccessPage";
import {ENV} from "./util/Util"
import ErrorPage from "./components/final/ErrorPage";

export const Context = createContext({});
export const ContextProvider = Context.Provider;

function App() {

  const [data, setData] = useState({
    uploadId: null,
    token: "",
    oib: "",
    mail: "",
    uploadHash: "",
    images: [null, null]
  });

  return (
    <Router basename={ENV.REACT_APP_HOMEPAGE_BASENAME}>
      <ContextProvider value={{uploadData: [data, setData]}}>
        <Route exact path={"/"} component={HomePage}/>
        <Route exact path={ENV.REACT_APP_DOCUMENT_UPLOAD_PAGE}>
          {data.token ? <UploadDocumentsPage/> : <Redirect to={"/"}/>}
        </Route>
        <Route exact path={ENV.REACT_APP_SUCCESS_PAGE} component={SuccessPage}/>
        <Route exact path={ENV.REACT_APP_ERROR_PAGE} component={ErrorPage}/>
      </ContextProvider>
    </Router>
  );
}

export default App;
